<template>
  <div class="temperature-container bg-light pb-2" v-show="device">
    <div class="row">
      <div class="col-12 align-items-md-left">
        <h1 class="sct2-title">
          {{ $t("temperatureHistory") }}
        </h1>
      </div>
      <div class="col-12 col-lg-8 py-3">
        <div class="sct2-history-section">
          <div
            class="
              sct2-card
              d-flex
              justify-content-around
              col-12
              align-items-center
            "
          >
            <chevron
              :orientation="'left'"
              :pointer="true"
              v-on:click.native="prev_period()"
            />
            <span>{{ title_range }}</span>
            <chevron
              :orientation="'right'"
              :pointer="true"
              v-on:click.native="next_period()"
            />
          </div>

          <div class="sct2-card" style="min-width: 75%; padding:0" v-if="series.length">
            <h5 class="sct2-card-title">{{ $t("temperatureStatement") }}</h5>
            <apexchart
              type="line"
              height="500px"
              width="100%"
              :options="chartOptions"
              :series="series"
            />
          </div>

          <div class="d-none d-md-block col-md-3 p-0">
            <b-button
              class="b-btn-checkout sct2-button"
              block
              variant="primary"
              @click="on_export"
            >
              <div class="sct2-button-text">
                {{ $t("exportData") }}
              </div>
            </b-button>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-4 py-3">
        <div v-if="alert_config" class="sct2-history-section">
          <h4 class="sct2-history-section-title">
            {{ $t("configTemperatureAlertTitle") }}
          </h4>
          <div
            class="
              sct2-card
              d-flex
              justify-content-between
              align-items-center
              col-12
            "
          >
            <label class="mb-0 sct2-label">{{
              $t("emailAlertsEnabled")
            }}</label>
            <app-toggle
              id="alert_enable"
              name="check-button"
              :checked.sync="alert_config.alert_enabled"
            />
          </div>
          <label class="col-12 m-0 p-0 sct2-label"
            >{{ $t("minTemperature") }} :
            <span class="font-weight-bold"
              >{{ alert_config.min_threshold }}°C</span
            >
          </label>
          <input
            class="col-12"
            type="range"
            min="-30"
            max="50"
            id="min_threshold"
            @change="changeMin"
            v-model="alert_config.min_threshold"
          />
          <label class="col-12 m-0 p-0 sct2-label"
            >{{ $t("maxTemperature") }} :
            <span class="font-weight-bold"
              >{{ alert_config.max_threshold }}°C</span
            >
          </label>
          <input
            class="col-12 slider"
            type="range"
            id="max_threshold"
            min="-30"
            max="50"
            v-model="alert_config.max_threshold"
            @change="changeMax"
          />
          <div class="p-0 col-md-12">
            <b-button
              id="config-update"
              class="b-btn-checkout sct2-button"
              block
              variant="primary"
              @click="on_update_config"
            >
              <div class="sct2-button-text" v-if="!isValidated">
                {{ $t("Save") }}
              </div>
              <div class="sct2-button-text" v-else>
                {{ $t("Saved") }}
                <check :iconColor="'white'" />
              </div>
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { bus } from "../event-bus";
import { HTTP } from "../http-constants";
import VueApexCharts from "vue-apexcharts";
import Chevron from "../components/svg/chevron.vue";
import AppToggle from "../components/AppToggle.vue";
import Check from "../components/svg/check.vue";

let moment = require("moment");

export default {
  components: {
    apexchart: VueApexCharts,
    Chevron,
    Check,
    AppToggle,
  },
  data: function () {
    return {
      device: null,
      values: [],
      series: [],
      isValidated: false,
      alert_config: {},
      date_start: null,
      date_end: null,
      chartOptions: {
        plotOptions: {},
        chart: {
          toolbar: {
            show: false,
          },
          animations: {
            enabled: false,
          },
        },
        annotations: {
          yaxis: [],
        },
        stroke: {
          width: 3,
        },
        xaxis: {
          type: "datetime",
          categories: [],
        },
        yaxis: {
          min: (min) => {
            if (
              this.alert_config.alert_enabled &&
              this.alert_config.min_threshold - 1 < min
            ) {
              return this.alert_config.min_threshold - 1;
            }
            return min;
          },
          max: (max) => {
            if (
              this.alert_config.alert_enabled &&
              this.alert_config.max_threshold + 1 > max
            ) {
              return this.alert_config.max_threshold + 1;
            }
            return max;
          },
        },
        tooltip: {
          x: {
            format: "dd MMM yyyy HH:mm",
          },
        },
      },
    };
  },
  computed: {
    title_range: function () {
      if (this.date_start == null) {
        return "...";
      }

      let _diff = moment(this.date_end).diff(moment(this.date_start), "hours");
      let _title = moment(this.date_start).format("DD/MM/YYYY");
      if (_diff > 24) {
        _title += " - " + moment(this.date_end).format("DD/MM/YYYY");
      }
      return _title;
    },
  },
  methods: {
    display() {
      console.log("display temperature: " + this.values.length + "elems");

      var now = new Date();
      let _values = this.values;

      // this.chartOptions.title = { text: "Temperature reports" };

      let min_series = _values.map((a) => [a.datetime.getTime(), a.min_temp]);
      let max_series = _values.map((a) => [a.datetime.getTime(), a.max_temp]);

      this.chartOptions.xaxis.min = this.date_start.getTime();
      this.chartOptions.xaxis.max = this.date_end.getTime();

      let _annotations = { yaxis: [] };
      if (this.alert_config.alert_enabled) {
        _annotations = {
          yaxis: [
            {
              y: this.alert_config.min_threshold,
              y2: this.alert_config.max_threshold,
              borderColor: "#000",
              fillColor: "#FEB019",
              label: {
                text: "Value range",
              },
            },
          ],
        };
      }

      this.chartOptions = {
        ...this.chartOptions,
        ...{
          annotations: _annotations,
        },
      };

      let _series = [
        { name: "minimum", data: min_series },
        { name: "maximum", data: max_series },
      ];
      this.series = _series;

      console.log("series updated");
    },
    prev_period() {
      let _diff = moment(this.date_end).diff(this.date_start, "days");
      this.date_start = moment(this.date_start)
        .subtract(_diff, "days")
        .toDate();
      this.date_end = moment(this.date_end).subtract(_diff, "days").toDate();
      this.load();
    },
    next_period() {
      if (moment(new Date()).diff(this.date_end, "hours") > 0) {
      let _diff = moment(this.date_end).diff(this.date_start, "days");
      this.date_start = moment(this.date_start).add(_diff, "days").toDate();
      this.date_end = moment(this.date_end).add(_diff, "days").toDate();
      this.load();
      }
    },
    changeMin() {
      let config = this.alert_config;
      if (parseInt(config.min_threshold) > parseInt(config.max_threshold) - 1) {
        this.alert_config.min_threshold = parseInt(config.max_threshold) - 1;
      }
    },
    changeMax() {
      let config = this.alert_config;
      if (parseInt(config.min_threshold) + 1 > parseInt(config.max_threshold)) {
        config.max_threshold = parseInt(config.min_threshold) + 1;
      }
    },
    on_update_config() {
      var self = this;
      console.log(this.alert_config);
      HTTP.patch(
        "/devices/" + self.device.id + "/temperature_config/",
        this.alert_config
      )
        .then(function (re) {
          self.alert_config = re.data;
          self.display();
          self.isValidated = true;
          setTimeout(() => {
            self.isValidated = false;
          }, 1500);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    get_config() {
      let self = this;

      HTTP.get("/devices/" + this.device.id + "/temperature_config/")
        .then(function (re) {
          self.alert_config = { ...re.data };
          console.log(self.alert_config);
          self.display();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    load() {
      let self = this;
      console.log("Request " + moment(this.date_start).format("YYYY-MM-DD"));
      let params = "limit=400&timestamp=" + moment(this.date_start).unix();
      if (this.date_end) {
        params += "&timestamp_max=" + moment(this.date_end).unix();
      }
      HTTP.get("/devices/" + this.device.id + "/temperature_reports/?" + params)
        .then(function (re) {
          self.values = [];
          for (var i = 0; i < re.data.length; i++) {
            var elem = re.data[i];
            self.values.push({
              datetime: new Date(elem.datetime),
              min_temp: elem.min_temp,
              max_temp: elem.max_temp,
            });
          }
          self.get_config();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    on_export() {
      let filename = "export_tempertature_" + this.device.serial + ".csv";
      let self = this;
      HTTP({
        url: "/devices/" + this.device.id + "/temperature_reports_csv/",
        method: "GET",
        responseType: "blob",
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
    },
  },
  created: function () {
    bus.$on("tracker_panel", (elem) => {
      var action = elem.action;
      if (action == "temperature") {
        this.device = elem.tracker;
        this.date_start = moment().startOf("day").subtract(1, "days").toDate();
        this.date_end = moment().endOf("day").toDate();
        this.load();
      } else {
        this.device = null;
      }
    });
  },
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap");

.temperature-container {
  padding: 1.5em;
  font-family: "Montserrat", sans-serif;
}

.sct2-history-section {
  display: flex;
  flex-direction: column;
  gap: 1em;

  &-title {
    font-family: "Montserrat";
    font-weight: 700;
    font-size: 22px;

    color: #050328;
  }
}

.sct2-title {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 800;

  color: #050328;
}

.sct2-card {
  padding: 1em;
  background: #ffffff;
  border: 1px solid #ebebf0;
  border-radius: 8px;
  align-items: center;

  &-title {
    font-family: "Montserrat";
    font-weight: 600;
    padding: 1em;

    color: #000000;
  }
}

.sct2-label {
  font-family: "Open Sans";
  font-weight: 600;
  font-size: 14px;

  color: #050328;
}

input[type="range"]::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  top: 0px;
  z-index: 1;
  width: 16px;
  height: 16px;
  cursor: pointer;
  -webkit-box-shadow: 0px -1px 8px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0px -1px 8px rgba(0, 0, 0, 0.2);
  box-shadow: 0px -1px 8px rgba(0, 0, 0, 0.2);
  -webkit-border-radius: 40px;
  -moz-border-radius: 40px;
  border-radius: 40px;
  background-color: #ffffff !important;
  color: white !important;
}

.sct2-button {
  background: #0090f8;
  border: 1px solid #0090f8;
  box-shadow: 0px 0px 10px rgba(0, 144, 248, 0.25);
  backdrop-filter: blur(80px);
  border-radius: 8px;
  padding: 1em 0;

  &-text {
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 0.5em;
  }

  &:focus {
    box-shadow: none;
    border: 1px solid #0090f8;
  }

  &:active {
    background: #0090f8 !important;
    box-shadow: 0px 0px 10px rgba(0, 144, 248, 0.25) !important;
    backdrop-filter: blur(80px) !important;
    border-radius: 8px;
    border: 1px solid #0090f8;
  }

  &:disabled {
    background: lightslategrey;
    border: 1px solid lightslategrey;
  }
}
</style>